var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticClass: "topimg",
        attrs: { src: require("../assets/newimg/images/logo_03_03.png") }
      }),
      _vm._v(" "),
      _c(
        "form",
        [
          _c("div", { staticClass: "input-control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.iccid,
                  expression: "iccid"
                }
              ],
              attrs: { placeholder: "输入设备号" },
              domProps: { value: _vm.iccid },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.iccid = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.wxReady
              ? _c("img", {
                  staticClass: "addon",
                  attrs: { src: require("../assets/images/scan.png") },
                  on: { click: _vm.handleScan }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.cardCheckOK == true && _vm.needAuth == 1 && _vm.binded == false
            ? [
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.mobile,
                        expression: "ruleForm.mobile"
                      }
                    ],
                    attrs: { placeholder: "输入手机号" },
                    domProps: { value: _vm.ruleForm.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "mobile", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "smscode", on: { click: _vm.handleSms } },
                    [_vm._v(_vm._s(_vm.smsBtnTxt))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.code,
                        expression: "ruleForm.code"
                      }
                    ],
                    attrs: { placeholder: "输入验证码" },
                    domProps: { value: _vm.ruleForm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "code", $event.target.value)
                      }
                    }
                  })
                ])
              ]
            : _vm.binded == true && _vm.needAuth == 1
            ? [
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.bindInfo.mobile,
                        expression: "bindInfo.mobile"
                      }
                    ],
                    attrs: { disabled: "", placeholder: "输入手机号" },
                    domProps: { value: _vm.bindInfo.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.bindInfo, "mobile", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "font-size": ".24rem", color: "#000" } },
                  [
                    _vm._v(
                      "以上信息为此号码当前绑定的使用人信息，如有疑问，请联系客服"
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.cardCheckOK == false
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleCheckCard } },
                [_vm._v("查询")]
              )
            : _vm.binded == false
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleBindCard } },
                [_vm._v("绑定")]
              )
            : _vm.binded == true
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleQueryCard } },
                [_vm._v("确认")]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false },
          model: {
            value: _vm.xieyimodal,
            callback: function($$v) {
              _vm.xieyimodal = $$v
            },
            expression: "xieyimodal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "xieyibox",
              style: { maxHeight: _vm.dialogHeight, overflowY: "scroll" }
            },
            [
              _c("div", { staticClass: "xy-title" }, [_vm._v("免责声明")]),
              _vm._v(" "),
              _c("div", { staticClass: "xy-content" }, [
                _c("div", { staticClass: "xy-heading" }, [_vm._v("购买须知")]),
                _vm._v(
                  "\n        1、套餐规则\n\n        1）套餐随用随充，均为全国流量（不含港澳台和运营商指定限制上网区域，目前运营商限制区域包括：新疆全境、西藏全境、云南全境）。\n\n        2）套餐分为基础套餐和定额套餐。基础套餐指按固定周期（月/季/半年/年）订购的流量套餐，周期内每月享有固定流量额度；定额套餐是指套餐有效期内流量总量为固定值的套餐。\n\n        3）当前若无其他有效基础套餐或定额套餐，所购套餐立即生效，购买时间即生效时间。当前仅可有一个基础套餐或定额套餐生效，套餐到期后立即失效。当基础套餐最后一个周期流量用尽且无可用的加油包或定额套餐流量用尽时，若此时订购新的基础套餐或定额套餐，则原套餐失效，新购套餐生效。\n\n        4）购买套餐后须完成实名认证方可使用：购买双网套餐且完成全部实名认证后，则可切换网络使用，若只对其中某一运营商实名认证，则无法切换网络使用；如需切换网络使用，则需对另一运营商实名认证。\n\n        5）由于中国移动管控要求，当月移动网络流量会有40G的用量限制，超出后为您提供中国电信的网络流量，请您务必实名认证并激活电信卡。\n\n        6）根据工信部和基础运营商的政策变化情况，可能对流量套餐价格进行浮动调整。\n\n        7）离网（无有效套餐）180天内可随时启用；离网超过180天，请联系客服确认是否可以重新启用。\n\n        2、基础套餐\n\n        1）套餐有效期：基础套餐中，月包套餐有效期为30个自然日；季包套餐有效期为90个自然日；半年包套餐有效期为180个自然日；年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以月包套餐为例：2025年6月10日激活使用，月包到期时间为2025年7月10日。\n\n        2）流量结转规则：长周期（每30个自然日为一个周期，简称：期）基础套餐的当期未使用完流量不可结转至次期，即当期未用尽流量将在本期最后一天23:59自动清零。当期流量用尽可自主选购“加油包”继续使用。\n\n        3）加油包：必须依托于一个正在生效中的基础套餐方可购买。加油包的网络类别、覆盖地区等属性均与当前基础套餐相同，购买后立即生效，当期基础套餐到期后，加油包亦同步失效，流量自动清零不可结转。\n\n        4）退订规则：\n\n        ①月包套餐：退订时，已使用流量部分按照1元/G标准收取费用，最高不超过当月套餐购买价格；套餐到期后，不支持退订。\n\n        ②长周期套餐（季包套餐、半年包套餐、年包套餐）：退订时，已使用流量部分按照【使用月数（含当月）*月包套餐价格】的标准收取费用，最高不超过该长周期套餐购买价格；套餐剩余使用期限小于或等于一个月的，不予退款。\n\n        ③退订顺序：基础套餐退订时如有流量未用尽的加油包，则先退订加油包再退订基础套餐。加油包退款规则同月包基础套餐。\n\n        ④退款说明：退款金额为实际支付金额扣除前述应收取费用。若您在支付时选择使用优惠券，则套餐退订时，所使用优惠券（如有）无法退还。\n\n        3、定额套餐\n\n        1）套餐有效期：定额套餐中，半年包套餐有效期为90个自然日，180个自然日，年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以年包套餐为例：2025年6月10日激活使用，年包到期时间为2026年6月5日。\n\n        2）流量使用规则：套餐有效期内，套餐内流量可自由使用，流量用尽时套餐自动失效。定额套餐不支持加油包的订购，套餐到期后，未使用流量自动清零，不可延期或结转；流量用尽但未到期时，需重新购买流量套餐使用。\n\n        3）退订规则：退订时，已使用的流量部分将按照1元/G的标准收取费用，且所收取的费用最高不超过该流量包的购买价格退款金额为实际支付金额扣除前述应收取费用。套餐到期后，不支持退订。若您在支付时选择使用优惠券，则套餐退订后，所使用优惠券（如有）无法退还。\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn" }, [
                _c("div", { on: { click: _vm.confirmxieyi } }, [
                  _vm._v("同意")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.xieyimodal = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "title" }, [_vm._v("温馨提示：")]),
      _vm._v(" "),
      _c("div", [_vm._v("1：卡号为卡芯后的数字，短号为设备背面的字母和数字")]),
      _vm._v(" "),
      _c("div", [_vm._v("2：因产品实名使用之后，无法二次销售，故无法退卡")]),
      _vm._v(" "),
      _c("div", [_vm._v("3：绑卡时请核实该地区是否能使用，谨慎操作")]),
      _vm._v(" "),
      _c("div", [_vm._v("4：新疆、西藏、云南、港澳台不可使用!")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a89e4f7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89e4f7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bind.vue
// module id = null
// module chunks = 